import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormGroup} from '@angular/forms';
import {FormValidationService} from '../../services/form-validation/form-validation.service';
import {TruckFormService} from '../../services/truck-form/truck-form.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {

  router: Router;
  @Input() truckForm!: FormGroup;
  @Input() assumptionsForm!: FormGroup;
  private previousRouter = '/calculadora';

  constructor(router: Router, private formValidationService: FormValidationService, private truckFormService: TruckFormService) {
    this.router = router;
    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe(event => {
    //     if (event instanceof NavigationEnd) {
    //       if (event.url === '/calculadora') {
    //         console.log(this.truckForm);
    //       }
    //       this.previousRouter = event.url;
    //     }
    //   });
  }

  ngOnInit(): void {
  }

  printCurrentRoute(): void {

    console.log(this.router.url);
    console.log(this.previousRouter);
    if (this.previousRouter === this.router.url) {
      return;
    }

    if (this.previousRouter === '/calculadora') {
      console.log(this.truckForm);
    }
    this.previousRouter = this.router.url;
  }

  // submitTruckForm(): void {
  //   this.truckFormComponent.submitForm();
  // }

  getCurrentClass(): string {
    return this.router.url === '/calculadora' ? 'calculator' : this.router.url === '/supuestos' ? 'assumptions' : 'results';
  }

  saveAndSubmit(futureRouteUrl: string): void {
    // this.truckFormService.saveAndSubmit(futureRouteUrl, this.truckForm, this.assumptionsForm);
    if (this.router.url === futureRouteUrl) {
      return;
    }

    if (this.router.url === '/calculadora') {
      if (!this.formValidationService.formIsValid(this.truckForm)) {
        return;
      }

      // this.truckFormService.saveTruckFormGroup(this.truckForm);
    }

    if (this.router.url === '/supuestos') {
      if (!this.formValidationService.formIsValid(this.assumptionsForm)) {
        return;
      }

      this.truckFormService.saveAssumptionsForm(this.assumptionsForm);
    }

    if (futureRouteUrl === '/resultados') {
      if (!this.truckFormService.truckFormGroup || !this.truckFormService.assumptionsForm) {
        return;
      }

      this.truckFormService.calculateTCO();
    }

    this.router.navigateByUrl(futureRouteUrl);
  }

}
